import QRCode from "qrcode";

/**
 * Generates a QR Code in SVG format.
 * @param {string} text Text to be converted to a QR Code.
 * @returns {Promise<string>} A Promise that resolves with a string containing the QR Code in SVG format.
 */
export async function generateQRCodeSVG(text: string): Promise<string> {
  try {
    const qrCodeSVG = await QRCode.toString(text, { type: "svg" });
    return qrCodeSVG;
  } catch (err) {
    console.error("Erro ao gerar o QR Code em SVG:", err);
    throw err;
  }
}
